import _extends from "@babel/runtime/helpers/extends";

var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/core/ThemeProvider/ThemeProvider.js",
    _this = this;

import React, { useContext, useMemo } from 'react';
import { defaultTheme, getDefaultTheme } from '../../theme';
import getComponentName from '../../helpers/getComponentName';
import { kioskTheme, getKioskTheme } from '../../theme/kiosk';
import { advanceTheme, getAdvanceTheme } from '../../theme/advance';
import { dlsStandard2Theme, getDlsStandard2Theme } from '../../theme/dlsStandard2';
/**
 * DLS Theme Context
 * @type {React.Context<{coreTheme: {}}>}
 */

export var ThemeContext = /*#__PURE__*/React.createContext({
  coreTheme: defaultTheme
});
/**
 * Inject ThemeContext values into the component props, namely `coreTheme`
 * Ensure any of the props used in the target component do not use `coreTheme` to prevent prop overwriting.
 *
 * @param Component React component which receives the injected prop from ThemeContext.
 * @return {React.Component} New react component.
 */

export var withTheme = function withTheme(Component) {
  var WithCoreContextComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
    var themeContext = useContext(ThemeContext) || {};
    var theme = themeContext.theme || defaultTheme;
    return /*#__PURE__*/React.createElement(Component, _extends({}, props, {
      coreTheme: theme,
      ref: ref,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 31,
        columnNumber: 12
      }
    }));
  });
  WithCoreContextComponent.displayName = "DLSContext.".concat(getComponentName(Component));
  return WithCoreContextComponent;
};
/**
 * Hook for accessing DLS theme values in DLS components.
 * @return {{theme: {} }}
 */

export var useTheme = function useTheme() {
  var themeContext = useContext(ThemeContext) || {};
  var theme = themeContext.theme || defaultTheme;
  return {
    theme: theme
  };
};
var brands = {
  "default": {
    theme: defaultTheme,
    getTheme: getDefaultTheme
  },
  kiosk: {
    theme: kioskTheme,
    getTheme: getKioskTheme
  },
  advance: {
    theme: advanceTheme,
    getTheme: getAdvanceTheme
  },
  dlsStandard2: {
    theme: dlsStandard2Theme,
    getTheme: getDlsStandard2Theme
  }
};
/**
 * React Component to provide ThemeContext values to all the child components.
 */

export var ThemeProvider = function ThemeProvider(props) {
  // Memoize context values since global configs such as 'theme' do not change often.
  var themeValue = useMemo(function () {
    return {
      theme: props.theme ? brands[props.brand].getTheme(props.theme) : brands[props.brand].theme
    };
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: themeValue,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 83,
      columnNumber: 7
    }
  }, props.children));
};
ThemeProvider.defaultProps = {
  brand: 'default'
};